import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

export interface ToastConfig {
  message: string;
  type?: 'success' | 'error' | 'warning' | 'info';
  duration?: number;
}

@Injectable({
  providedIn: 'root'
})
export class ToastService {

  constructor(private snackBar: MatSnackBar) { }

  show(config: ToastConfig): void {
    const duration = config.duration || 3000;
    const panelClass = this.getPanelClass(config.type || 'info');

    this.snackBar.open(config.message, 'Close', {
      duration,
      panelClass,
      horizontalPosition: 'end',
      verticalPosition: 'top',
    });
  }

  success(message: string, duration?: number): void {
    this.show({ message, type: 'success', duration });
  }

  error(message: string, duration?: number): void {
    this.show({ message, type: 'error', duration });
  }

  warning(message: string, duration?: number): void {
    this.show({ message, type: 'warning', duration });
  }

  info(message: string, duration?: number): void {
    this.show({ message, type: 'info', duration });
  }

  private getPanelClass(type: string): string {
    switch (type) {
      case 'success':
        return 'success-snackbar';
      case 'error':
        return 'error-snackbar';
      case 'warning':
        return 'warning-snackbar';
      case 'info':
      default:
        return 'info-snackbar';
    }
  }
} 